import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import SearchDropdown from "../search-dropdown/SearchDropdown";
import clsx from "clsx";
import { useLocalizedString } from "@amzn/aws-marketing-identity-kit-localizations";
const MultiSelectWithSearch = forwardRef(({ name, label, field, isInvalid, isDisabled, isReadOnly = false, options, dropdownRef, errorMessage, selectLabel, itemLimit, itemWarningThreshold, selectionText, readOnlyLabel, ...props }, ref) => {
    const currentTags = field?.value || [];
    const reachedLimit = !!itemLimit && currentTags.length >= itemLimit;
    const { t } = useLocalizedString();
    const availableOptions = options
        .filter((option) => !currentTags.includes(option))
        .map((option) => ({ key: option, value: option }));
    const displayValues = options.map((option) => ({
        key: option,
        value: option,
    }));
    const handleAddTag = (tag) => {
        if (!isReadOnly && field) {
            const newTags = [...currentTags, tag];
            field.onChange(newTags);
        }
    };
    const handleRemoveTag = (index) => {
        if (!isReadOnly && field) {
            const newTags = currentTags.filter((_, i) => i !== index);
            field.onChange(newTags);
        }
    };
    const getLimitMessage = () => {
        if (isReadOnly || !itemLimit || !itemWarningThreshold || !selectionText)
            return null;
        const remaining = itemLimit - currentTags.length;
        if (remaining > itemWarningThreshold) {
            return (_jsx("span", { className: "pb-4", children: t(selectionText.default.replace("{0}", itemLimit.toString())) }));
        }
        if (remaining > 0) {
            return (_jsx("span", { className: "text-orange-600 pb-4", children: t(selectionText.lessEqualThanThreshold.replace("{0}", `${remaining} more ${remaining !== 1 ? "interests" : "interest"}`)) }));
        }
        if (reachedLimit) {
            return (_jsx("span", { className: "text-orange-600 pb-4", children: selectionText.full }));
        }
        return null;
    };
    return (_jsxs("div", { className: "flex flex-col w-full", ref: dropdownRef, children: [getLimitMessage(), !isReadOnly ? (_jsx("div", { className: "w-full", children: _jsx(SearchDropdown, { ...props, name: name, label: label, items: availableOptions, onSelectionChange: handleAddTag, isInvalid: isInvalid, errorMessage: errorMessage, isDisabled: isDisabled || availableOptions.length === 0 || reachedLimit, selectLabel: selectLabel, searchLabel: "", ref: ref, showCurrentSelected: false }) })) : (_jsx("div", { className: clsx("flex flex-col items-start px-0 py-4 sm:p-4 justify-center text-sm text-idk-disabled-text gap-1 h-auto overflow-hidden", currentTags.length === 0
                    ? "border-b border-[#ccccd1] min-h-[8.4rem]"
                    : "pt-4"), children: t(readOnlyLabel) })), currentTags.length > 0 && (_jsx("div", { className: clsx("flex flex-wrap gap-4 py-4 pl-4 min-h-[8.4rem]", isReadOnly ? "border-b border-[#ccccd1]" : ""), children: currentTags.map((tag, index) => options.includes(tag) && (_jsxs("div", { className: `flex items-center px-6 py-3 rounded-full text-sm ${isReadOnly
                        ? "bg-gray-100 text-gray-600"
                        : "bg-idk-gradient"}`, children: [_jsx("span", { children: t(displayValues.find((o) => o.value === tag)
                                ?.key) }), !isReadOnly && (_jsx("button", { "data-testid": "removeTagButton", type: "button", onClick: () => handleRemoveTag(index), onKeyDown: (e) => {
                                if (e.key === "Enter" || e.key === " ") {
                                    e.preventDefault();
                                    handleRemoveTag(index);
                                }
                            }, disabled: isDisabled, className: "ml-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 rounded-full disabled:opacity-50 p-1", "aria-label": "Remove tag", tabIndex: 0, children: _jsx("svg", { className: "w-4 h-4", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", stroke: "currentColor", strokeWidth: "2", strokeLinejoin: "round", children: _jsx("path", { d: "M1 15L15 1M15 15L1 1" }) }) }))] }, `${tag}-${index}`))) }))] }));
});
MultiSelectWithSearch.displayName = "MultiSelectWithSearch";
export default MultiSelectWithSearch;
//# sourceMappingURL=MultiSelectWithSearch.js.map